// extracted by mini-css-extract-plugin
module.exports = {"root":"ItemRequest_root__Q6dI1"};